<template>
    <div class="ai-recommendations-content">
        <ol v-if="!hasNoData">
            <li
                v-for="(recommendation, index) in sortedRecommendations"
                :key="index"
                class="ai-recommendations-content__item"
            >
                <div
                    class="ai-recommendations-content__item-title typographies-paragraph-medium-semibold"
                >
                    {{ recommendation.title }}
                </div>
                <div>{{ recommendation.description }}</div>
            </li>
        </ol>
        <NoInvoicingData
            v-if="hasNoData"
            :content="$t.__('overview.tabs.TabSummary.noRecommendations')"
        />
    </div>
</template>
<script>
import NoInvoicingData from 'vcomponents/AISummary/Content/NoInvoicingData.vue';

export default {
    components: {
        NoInvoicingData,
    },
    inject: ['getSummary'],
    computed: {
        summary() {
            return this.getSummary();
        },
        recommendations() {
            return this.summary ? this.summary.summary.output.recommendations : [];
        },
        hasNoData() {
            return !this.recommendations || this.recommendations.length === 0;
        },
        sortedRecommendations() {
            const priorityMap = {
                high: 3,
                medium: 2,
                low: 1,
            };

            return [...this.recommendations].sort((a, b) => {
                return priorityMap[b.priority] - priorityMap[a.priority];
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.ai-recommendations-content {
    ol {
        counter-reset: item;
        list-style: none;
        margin: 0;
    }

    &__item {
        & + & {
            border-top: 1px solid var(--colors-common-border-lighter);
            margin-top: var(--spacing-3);
            padding: var(--spacing-3) 0 0;
        }

        &-title {
            &:before {
                counter-increment: item;
                content: counter(item) ' - ';
            }

            margin: 0 0 var(--spacing-1);
        }
    }
}
</style>
